import React from "react";
import "./RewardSecOne.css"





function RewardSecOne() {
    return (
        <>
            <div className="four_rewards_block1">
                <div className="share4rewards-container">
                    <div className="SD_textwrapper">
                        <h3>Our Exam is covered by most insurance, including Medicare!</h3>
                        <p className="paraTag">
                            <span>Sharing our program is as simple</span> as handing a flier to customers who appear to be over the age of 35. Many of them will qualify!</p>
                        <div className="SDyellow_box">
                            <h2>Our quick, easy and non-invasive exam tests for:</h2>
                        </div>
                        <div className="block1_bottom_box">
                            <div className="bottom_box_inner">
                                <div className="block1_flex round_cls">
                                    <div className="round_cls_left">
                                        <p>Heart Attack Risk</p>
                                        <p>Diabetes with Complications</p>
                                        <p>Post Covid Complications</p>
                                        <p>Artery Inflammation and Disease</p>

                                    </div>
                                    <div className="round_cls_right">

                                        <p>Obesity Complications</p>
                                        <p>Multiple system dystrophy</p>
                                        <p>Pure autonomic failure</p>
                                        <p>Plus many more…</p>
                                    </div>

                                </div>
                                <div className="round_cls"><p>Nerve Damage (including that which can lead to organ failure)</p></div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
            <div className="four_rewards_block2">
                <div className="share4rewards-container">
                    <div className="SDblock2_inner">
                        <div className="SD_textwrapper2">
                            <img src="https://all-frontend-assets.s3.amazonaws.com/share4rewards/rewards_block2_img.webp" />
                            <div className="SDyellow_box">
                                <h2>The Reward Program</h2>
                            </div>
                            <p>Our clinic is one of the only ones in the area offering this exam. It is very likely that your customers have never taken this exam at another practice. In just 15 minutes this exam will provide insights into a patient’s health and wellbeing unlike anything offered before. In the media we provide you, there is a list of diseases and symptoms. If your customer experiences at least one, they qualify. In the demographic studies surrounding this exam, over 80% of people are experiencing one of the qualifying symptoms!</p>
                            <p className="weight_600">
                                <span>Participation in our program is free! All we need from you is a signature, </span> and a commitment to share our media. There is no disruption to your business flow. If your customer meets the requirements, they can easily visit the website link or scan the QR code provided, or call a designated number tailored to your location!

                            </p>

                        </div>
                        <div className="block2_bottom_blk">
                            <label>For every customer that schedules and comes in for an appointment, we will reward your company $10!</label>
                            <p> We suggest that you share 50% with your employees and keep 50% as revenue.</p>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default RewardSecOne;